module.exports = __webpack_public_path__ + "img/Logo-negocio.17b2e053.png";